// Точка входа только выбирает приложение. Китайский фотограф получает облегчённую
// страницу /cn (десятки КБ), остальные — полное ERP. Сервер в Новосибирске, а /cn
// открывают в Китае, поэтому в общий чанк отсюда ничего тяжёлого импортировать нельзя.

const CN_ROLE = "ContentManagerCn"
const ROLE_CLAIM = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"

function isCnOnlyUser(): boolean {
    try {
        const token = localStorage.getItem("Token")
        if (!token) return false
        const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")))
        const roles: string[] = [].concat(payload[ROLE_CLAIM] ?? [])
        return roles.includes(CN_ROLE) && !roles.includes("Admin")
    } catch {
        return false
    }
}

const path = window.location.pathname
const isCnPath = path === "/cn" || path.startsWith("/cn/")
// У фотографов в закладках старый адрес china.…/watchtower — он тоже ведёт в /cn
const isChinaEntry = window.location.hostname.startsWith("china.") && ["/", "/login", "/watchtower"].includes(path)
// Старый экран — только по ссылке «旧版界面» внизу /cn (/watchtower?old), запасной на случай поломки
const wantsOld = new URLSearchParams(window.location.search).has("old")
const useCn = isCnPath || (!wantsOld && (isChinaEntry || isCnOnlyUser()))

if (useCn) {
    if (!isCnPath) window.history.replaceState(null, "", "/cn")
    import("./cn/main")
} else {
    import("./fullApp")
}

export {}
